import PropTypes from 'prop-types';
import React from 'react';
import autoBind from 'react-autobind';

import './ModalFooter.scss';

let disabled = 0;

class ModalFooter extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  componentWillReceiveProps(nextProps) {
    disabled = !nextProps.show;
  }

  handlePrimary(event) {
    if (disabled && !this.props.show) {
      return;
    }
    disabled = true;
    this.props.onPrimaryClick();
  }

  render() {
    const {
      onSecondaryClick,
      secondaryLabel,
      isSecondaryAlignLeft = false,
      primaryLabel,
      buttonObject,
      isDisabledPrimary,
    } = this.props;
    const alignClass = isSecondaryAlignLeft ? 'align-left' : 'align-right';
    let secondary = '';
    let positionPrimary = '--center';
    let primaryMarkup = (
      <button
        ref='btn'
        onClick={this.handlePrimary}
        disabled={isDisabledPrimary}
        className='btn submit-button'
      >
        <span className='btn-primary-label'>{primaryLabel}</span>
      </button>
    );
    if (onSecondaryClick && secondaryLabel) {
      secondary = (
        <div className={`wrapper-secondary ${alignClass}`}>
          <a onClick={onSecondaryClick} className='btn'>
            <span className='btn-primary-label'>{secondaryLabel}</span>
          </a>
        </div>
      );
      positionPrimary = '';
    }
    if (buttonObject) {
      primaryMarkup = buttonObject;
    }
    return (
      <div className='modal-footer--container'>
        {secondary}
        <div className={`wrapper-primary${positionPrimary}`}>
          {primaryMarkup}
        </div>
      </div>
    );
  }
}

ModalFooter.propTypes = {
  isSecondaryAlignLeft: PropTypes.bool,
  primaryLabel: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  secondaryLabel: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onPrimaryClick: PropTypes.func,
  onSecondaryClick: PropTypes.func,
  isDisabledPrimary: PropTypes.bool,
};

export default ModalFooter;
